// source: io/codedrills/proto/content/view.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js');
goog.object.extend(proto, io_codedrills_proto_judge_judge_pb);
var io_codedrills_proto_user_user_pb = require('../../../../io/codedrills/proto/user/user_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_user_pb);
var io_codedrills_proto_user_team_pb = require('../../../../io/codedrills/proto/user/team_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_team_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
goog.exportSymbol('proto.io.codedrills.proto.content.ArticleView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentViewWithPublish', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContestView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DataView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DataView.DataCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillContentView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillContentView.ContentCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillSectionView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.FillInTheBlanksView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.JobView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.MatchTheFollowingView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.McqView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ObjectiveOptionView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.OrderTheFollowingView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ProblemView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SkillView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SubjectiveView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SubmissionView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TeamView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TestView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.UserContentPreview', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContentView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.ContentView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContentView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContentView.displayName = 'proto.io.codedrills.proto.content.ContentView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DataView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.DataView.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.DataView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DataView.displayName = 'proto.io.codedrills.proto.content.DataView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ProblemView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ProblemView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ProblemView.displayName = 'proto.io.codedrills.proto.content.ProblemView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ArticleView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ArticleView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ArticleView.displayName = 'proto.io.codedrills.proto.content.ArticleView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContestView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.ContestView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContestView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContestView.displayName = 'proto.io.codedrills.proto.content.ContestView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TestView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.TestView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.TestView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TestView.displayName = 'proto.io.codedrills.proto.content.TestView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.DrillView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.DrillView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillView.displayName = 'proto.io.codedrills.proto.content.DrillView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillSectionView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.DrillSectionView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.DrillSectionView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillSectionView.displayName = 'proto.io.codedrills.proto.content.DrillSectionView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillContentView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.DrillContentView.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.DrillContentView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillContentView.displayName = 'proto.io.codedrills.proto.content.DrillContentView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TeamView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.TeamView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.TeamView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TeamView.displayName = 'proto.io.codedrills.proto.content.TeamView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SkillView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.SkillView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SkillView.displayName = 'proto.io.codedrills.proto.content.SkillView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.McqView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.McqView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.McqView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.McqView.displayName = 'proto.io.codedrills.proto.content.McqView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ObjectiveOptionView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ObjectiveOptionView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ObjectiveOptionView.displayName = 'proto.io.codedrills.proto.content.ObjectiveOptionView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SubjectiveView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.SubjectiveView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SubjectiveView.displayName = 'proto.io.codedrills.proto.content.SubjectiveView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.FillInTheBlanksView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.FillInTheBlanksView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.FillInTheBlanksView.displayName = 'proto.io.codedrills.proto.content.FillInTheBlanksView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.MatchTheFollowingView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.MatchTheFollowingView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.MatchTheFollowingView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.MatchTheFollowingView.displayName = 'proto.io.codedrills.proto.content.MatchTheFollowingView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.OrderTheFollowingView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.OrderTheFollowingView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.OrderTheFollowingView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.OrderTheFollowingView.displayName = 'proto.io.codedrills.proto.content.OrderTheFollowingView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.JobView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.JobView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.JobView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.JobView.displayName = 'proto.io.codedrills.proto.content.JobView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.UserContentPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.UserContentPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.UserContentPreview.displayName = 'proto.io.codedrills.proto.content.UserContentPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SubmissionView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.SubmissionView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.SubmissionView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SubmissionView.displayName = 'proto.io.codedrills.proto.content.SubmissionView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContentViewWithPublish = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContentViewWithPublish, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContentViewWithPublish.displayName = 'proto.io.codedrills.proto.content.ContentViewWithPublish';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.ContentView.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContentView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContentView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContentView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    url: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createdOn: jspb.Message.getFieldWithDefault(msg, 7, 0),
    type: jspb.Message.getFieldWithDefault(msg, 10, 0),
    metaData: (f = msg.getMetaData()) && io_codedrills_proto_content_content_pb.MetaData.toObject(includeInstance, f),
    dataView: (f = msg.getDataView()) && proto.io.codedrills.proto.content.DataView.toObject(includeInstance, f),
    childPreviewsList: jspb.Message.toObjectList(msg.getChildPreviewsList(),
    proto.io.codedrills.proto.content.UserContentPreview.toObject, includeInstance),
    customerId: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.content.ContentView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContentView;
  return proto.io.codedrills.proto.content.ContentView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContentView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.content.ContentView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedOn(value);
      break;
    case 10:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 11:
      var value = new io_codedrills_proto_content_content_pb.MetaData;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    case 12:
      var value = new proto.io.codedrills.proto.content.DataView;
      reader.readMessage(value,proto.io.codedrills.proto.content.DataView.deserializeBinaryFromReader);
      msg.setDataView(value);
      break;
    case 13:
      var value = new proto.io.codedrills.proto.content.UserContentPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserContentPreview.deserializeBinaryFromReader);
      msg.addChildPreviews(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContentView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContentView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContentView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedOn();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      io_codedrills_proto_content_content_pb.MetaData.serializeBinaryToWriter
    );
  }
  f = message.getDataView();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.io.codedrills.proto.content.DataView.serializeBinaryToWriter
    );
  }
  f = message.getChildPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.io.codedrills.proto.content.UserContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_by = 6;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 created_on = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getCreatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setCreatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional ContentType type = 10;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional MetaData meta_data = 11;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.MetaData, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
*/
proto.io.codedrills.proto.content.ContentView.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentView.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DataView data_view = 12;
 * @return {?proto.io.codedrills.proto.content.DataView}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getDataView = function() {
  return /** @type{?proto.io.codedrills.proto.content.DataView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.DataView, 12));
};


/**
 * @param {?proto.io.codedrills.proto.content.DataView|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
*/
proto.io.codedrills.proto.content.ContentView.prototype.setDataView = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.clearDataView = function() {
  return this.setDataView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentView.prototype.hasDataView = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated UserContentPreview child_previews = 13;
 * @return {!Array<!proto.io.codedrills.proto.content.UserContentPreview>}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getChildPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.UserContentPreview, 13));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserContentPreview>} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
*/
proto.io.codedrills.proto.content.ContentView.prototype.setChildPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.content.ContentView.prototype.addChildPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.io.codedrills.proto.content.UserContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.clearChildPreviewsList = function() {
  return this.setChildPreviewsList([]);
};


/**
 * optional int32 customer_id = 14;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentView.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentView} returns this
 */
proto.io.codedrills.proto.content.ContentView.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.DataView.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.DataView.DataCase = {
  DATA_NOT_SET: 0,
  PROBLEM_VIEW: 1,
  ARTICLE_VIEW: 2,
  CONTEST_VIEW: 3,
  DRILL_VIEW: 4,
  TEST_VIEW: 5,
  MCQ_VIEW: 6,
  SKILL_VIEW: 7,
  SUBJECTIVE_VIEW: 8,
  JOB_VIEW: 9,
  FILL_IN_THE_BLANKS_VIEW: 10,
  MATCH_THE_FOLLOWING_VIEW: 11,
  ORDER_THE_FOLLOWING_VIEW: 12
};

/**
 * @return {proto.io.codedrills.proto.content.DataView.DataCase}
 */
proto.io.codedrills.proto.content.DataView.prototype.getDataCase = function() {
  return /** @type {proto.io.codedrills.proto.content.DataView.DataCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.DataView.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DataView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DataView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DataView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DataView.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemView: (f = msg.getProblemView()) && proto.io.codedrills.proto.content.ProblemView.toObject(includeInstance, f),
    articleView: (f = msg.getArticleView()) && proto.io.codedrills.proto.content.ArticleView.toObject(includeInstance, f),
    contestView: (f = msg.getContestView()) && proto.io.codedrills.proto.content.ContestView.toObject(includeInstance, f),
    drillView: (f = msg.getDrillView()) && proto.io.codedrills.proto.content.DrillView.toObject(includeInstance, f),
    testView: (f = msg.getTestView()) && proto.io.codedrills.proto.content.TestView.toObject(includeInstance, f),
    mcqView: (f = msg.getMcqView()) && proto.io.codedrills.proto.content.McqView.toObject(includeInstance, f),
    skillView: (f = msg.getSkillView()) && proto.io.codedrills.proto.content.SkillView.toObject(includeInstance, f),
    subjectiveView: (f = msg.getSubjectiveView()) && proto.io.codedrills.proto.content.SubjectiveView.toObject(includeInstance, f),
    jobView: (f = msg.getJobView()) && proto.io.codedrills.proto.content.JobView.toObject(includeInstance, f),
    fillInTheBlanksView: (f = msg.getFillInTheBlanksView()) && proto.io.codedrills.proto.content.FillInTheBlanksView.toObject(includeInstance, f),
    matchTheFollowingView: (f = msg.getMatchTheFollowingView()) && proto.io.codedrills.proto.content.MatchTheFollowingView.toObject(includeInstance, f),
    orderTheFollowingView: (f = msg.getOrderTheFollowingView()) && proto.io.codedrills.proto.content.OrderTheFollowingView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DataView}
 */
proto.io.codedrills.proto.content.DataView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DataView;
  return proto.io.codedrills.proto.content.DataView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DataView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DataView}
 */
proto.io.codedrills.proto.content.DataView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.ProblemView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ProblemView.deserializeBinaryFromReader);
      msg.setProblemView(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ArticleView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ArticleView.deserializeBinaryFromReader);
      msg.setArticleView(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.ContestView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContestView.deserializeBinaryFromReader);
      msg.setContestView(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.content.DrillView;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillView.deserializeBinaryFromReader);
      msg.setDrillView(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.content.TestView;
      reader.readMessage(value,proto.io.codedrills.proto.content.TestView.deserializeBinaryFromReader);
      msg.setTestView(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.McqView;
      reader.readMessage(value,proto.io.codedrills.proto.content.McqView.deserializeBinaryFromReader);
      msg.setMcqView(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.content.SkillView;
      reader.readMessage(value,proto.io.codedrills.proto.content.SkillView.deserializeBinaryFromReader);
      msg.setSkillView(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.content.SubjectiveView;
      reader.readMessage(value,proto.io.codedrills.proto.content.SubjectiveView.deserializeBinaryFromReader);
      msg.setSubjectiveView(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.content.JobView;
      reader.readMessage(value,proto.io.codedrills.proto.content.JobView.deserializeBinaryFromReader);
      msg.setJobView(value);
      break;
    case 10:
      var value = new proto.io.codedrills.proto.content.FillInTheBlanksView;
      reader.readMessage(value,proto.io.codedrills.proto.content.FillInTheBlanksView.deserializeBinaryFromReader);
      msg.setFillInTheBlanksView(value);
      break;
    case 11:
      var value = new proto.io.codedrills.proto.content.MatchTheFollowingView;
      reader.readMessage(value,proto.io.codedrills.proto.content.MatchTheFollowingView.deserializeBinaryFromReader);
      msg.setMatchTheFollowingView(value);
      break;
    case 12:
      var value = new proto.io.codedrills.proto.content.OrderTheFollowingView;
      reader.readMessage(value,proto.io.codedrills.proto.content.OrderTheFollowingView.deserializeBinaryFromReader);
      msg.setOrderTheFollowingView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DataView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DataView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DataView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DataView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.content.ProblemView.serializeBinaryToWriter
    );
  }
  f = message.getArticleView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ArticleView.serializeBinaryToWriter
    );
  }
  f = message.getContestView();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.ContestView.serializeBinaryToWriter
    );
  }
  f = message.getDrillView();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.content.DrillView.serializeBinaryToWriter
    );
  }
  f = message.getTestView();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.content.TestView.serializeBinaryToWriter
    );
  }
  f = message.getMcqView();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.content.McqView.serializeBinaryToWriter
    );
  }
  f = message.getSkillView();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.content.SkillView.serializeBinaryToWriter
    );
  }
  f = message.getSubjectiveView();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.content.SubjectiveView.serializeBinaryToWriter
    );
  }
  f = message.getJobView();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.content.JobView.serializeBinaryToWriter
    );
  }
  f = message.getFillInTheBlanksView();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.io.codedrills.proto.content.FillInTheBlanksView.serializeBinaryToWriter
    );
  }
  f = message.getMatchTheFollowingView();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.io.codedrills.proto.content.MatchTheFollowingView.serializeBinaryToWriter
    );
  }
  f = message.getOrderTheFollowingView();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.io.codedrills.proto.content.OrderTheFollowingView.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProblemView problem_view = 1;
 * @return {?proto.io.codedrills.proto.content.ProblemView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getProblemView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ProblemView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ProblemView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ProblemView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setProblemView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearProblemView = function() {
  return this.setProblemView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasProblemView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ArticleView article_view = 2;
 * @return {?proto.io.codedrills.proto.content.ArticleView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getArticleView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ArticleView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ArticleView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ArticleView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setArticleView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearArticleView = function() {
  return this.setArticleView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasArticleView = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ContestView contest_view = 3;
 * @return {?proto.io.codedrills.proto.content.ContestView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getContestView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContestView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContestView, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContestView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setContestView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearContestView = function() {
  return this.setContestView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasContestView = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DrillView drill_view = 4;
 * @return {?proto.io.codedrills.proto.content.DrillView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getDrillView = function() {
  return /** @type{?proto.io.codedrills.proto.content.DrillView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.DrillView, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.DrillView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setDrillView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearDrillView = function() {
  return this.setDrillView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasDrillView = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TestView test_view = 5;
 * @return {?proto.io.codedrills.proto.content.TestView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getTestView = function() {
  return /** @type{?proto.io.codedrills.proto.content.TestView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.TestView, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.TestView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setTestView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearTestView = function() {
  return this.setTestView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasTestView = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional McqView mcq_view = 6;
 * @return {?proto.io.codedrills.proto.content.McqView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getMcqView = function() {
  return /** @type{?proto.io.codedrills.proto.content.McqView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.McqView, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.McqView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setMcqView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearMcqView = function() {
  return this.setMcqView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasMcqView = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SkillView skill_view = 7;
 * @return {?proto.io.codedrills.proto.content.SkillView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getSkillView = function() {
  return /** @type{?proto.io.codedrills.proto.content.SkillView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.SkillView, 7));
};


/**
 * @param {?proto.io.codedrills.proto.content.SkillView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setSkillView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearSkillView = function() {
  return this.setSkillView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasSkillView = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubjectiveView subjective_view = 8;
 * @return {?proto.io.codedrills.proto.content.SubjectiveView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getSubjectiveView = function() {
  return /** @type{?proto.io.codedrills.proto.content.SubjectiveView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.SubjectiveView, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.SubjectiveView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setSubjectiveView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearSubjectiveView = function() {
  return this.setSubjectiveView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasSubjectiveView = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional JobView job_view = 9;
 * @return {?proto.io.codedrills.proto.content.JobView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getJobView = function() {
  return /** @type{?proto.io.codedrills.proto.content.JobView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.JobView, 9));
};


/**
 * @param {?proto.io.codedrills.proto.content.JobView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setJobView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearJobView = function() {
  return this.setJobView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasJobView = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional FillInTheBlanksView fill_in_the_blanks_view = 10;
 * @return {?proto.io.codedrills.proto.content.FillInTheBlanksView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getFillInTheBlanksView = function() {
  return /** @type{?proto.io.codedrills.proto.content.FillInTheBlanksView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.FillInTheBlanksView, 10));
};


/**
 * @param {?proto.io.codedrills.proto.content.FillInTheBlanksView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setFillInTheBlanksView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearFillInTheBlanksView = function() {
  return this.setFillInTheBlanksView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasFillInTheBlanksView = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional MatchTheFollowingView match_the_following_view = 11;
 * @return {?proto.io.codedrills.proto.content.MatchTheFollowingView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getMatchTheFollowingView = function() {
  return /** @type{?proto.io.codedrills.proto.content.MatchTheFollowingView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.MatchTheFollowingView, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.MatchTheFollowingView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setMatchTheFollowingView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearMatchTheFollowingView = function() {
  return this.setMatchTheFollowingView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasMatchTheFollowingView = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional OrderTheFollowingView order_the_following_view = 12;
 * @return {?proto.io.codedrills.proto.content.OrderTheFollowingView}
 */
proto.io.codedrills.proto.content.DataView.prototype.getOrderTheFollowingView = function() {
  return /** @type{?proto.io.codedrills.proto.content.OrderTheFollowingView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.OrderTheFollowingView, 12));
};


/**
 * @param {?proto.io.codedrills.proto.content.OrderTheFollowingView|undefined} value
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
*/
proto.io.codedrills.proto.content.DataView.prototype.setOrderTheFollowingView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.io.codedrills.proto.content.DataView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DataView} returns this
 */
proto.io.codedrills.proto.content.DataView.prototype.clearOrderTheFollowingView = function() {
  return this.setOrderTheFollowingView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DataView.prototype.hasOrderTheFollowingView = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ProblemView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ProblemView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ProblemView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementView: jspb.Message.getFieldWithDefault(msg, 1, ""),
    editorialView: jspb.Message.getFieldWithDefault(msg, 3, ""),
    maxSubmissionSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    problemMeta: (f = msg.getProblemMeta()) && io_codedrills_proto_judge_judge_pb.ProblemMeta.toObject(includeInstance, f),
    sqlInitView: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ProblemView}
 */
proto.io.codedrills.proto.content.ProblemView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ProblemView;
  return proto.io.codedrills.proto.content.ProblemView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ProblemView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ProblemView}
 */
proto.io.codedrills.proto.content.ProblemView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementView(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEditorialView(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxSubmissionSize(value);
      break;
    case 6:
      var value = new io_codedrills_proto_judge_judge_pb.ProblemMeta;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.ProblemMeta.deserializeBinaryFromReader);
      msg.setProblemMeta(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSqlInitView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ProblemView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ProblemView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ProblemView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementView();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEditorialView();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaxSubmissionSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProblemMeta();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      io_codedrills_proto_judge_judge_pb.ProblemMeta.serializeBinaryToWriter
    );
  }
  f = message.getSqlInitView();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string statement_view = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.getStatementView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
 */
proto.io.codedrills.proto.content.ProblemView.prototype.setStatementView = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string editorial_view = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.getEditorialView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
 */
proto.io.codedrills.proto.content.ProblemView.prototype.setEditorialView = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 max_submission_size = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.getMaxSubmissionSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
 */
proto.io.codedrills.proto.content.ProblemView.prototype.setMaxSubmissionSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional io.codedrills.proto.judge.ProblemMeta problem_meta = 6;
 * @return {?proto.io.codedrills.proto.judge.ProblemMeta}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.getProblemMeta = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemMeta} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_judge_judge_pb.ProblemMeta, 6));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
*/
proto.io.codedrills.proto.content.ProblemView.prototype.setProblemMeta = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
 */
proto.io.codedrills.proto.content.ProblemView.prototype.clearProblemMeta = function() {
  return this.setProblemMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.hasProblemMeta = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string sql_init_view = 7;
 * @return {string}
 */
proto.io.codedrills.proto.content.ProblemView.prototype.getSqlInitView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ProblemView} returns this
 */
proto.io.codedrills.proto.content.ProblemView.prototype.setSqlInitView = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ArticleView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ArticleView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ArticleView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ArticleView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementView: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ArticleView}
 */
proto.io.codedrills.proto.content.ArticleView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ArticleView;
  return proto.io.codedrills.proto.content.ArticleView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ArticleView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ArticleView}
 */
proto.io.codedrills.proto.content.ArticleView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ArticleView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ArticleView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ArticleView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ArticleView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementView();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string statement_view = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.ArticleView.prototype.getStatementView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ArticleView} returns this
 */
proto.io.codedrills.proto.content.ArticleView.prototype.setStatementView = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.ContestView.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContestView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContestView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContestView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContestView.toObject = function(includeInstance, msg) {
  var f, obj = {
    aboutHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rulesHtml: jspb.Message.getFieldWithDefault(msg, 2, ""),
    announcementsHtmlList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    scoreboardSettings: (f = msg.getScoreboardSettings()) && io_codedrills_proto_content_content_pb.ScoreboardSettings.toObject(includeInstance, f),
    problemOrderList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContestView}
 */
proto.io.codedrills.proto.content.ContestView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContestView;
  return proto.io.codedrills.proto.content.ContestView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContestView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContestView}
 */
proto.io.codedrills.proto.content.ContestView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAboutHtml(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRulesHtml(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnnouncementsHtml(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_content_pb.ScoreboardSettings;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ScoreboardSettings.deserializeBinaryFromReader);
      msg.setScoreboardSettings(value);
      break;
    case 5:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setProblemOrderList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContestView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContestView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContestView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContestView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAboutHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRulesHtml();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnnouncementsHtmlList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getScoreboardSettings();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_content_pb.ScoreboardSettings.serializeBinaryToWriter
    );
  }
  f = message.getProblemOrderList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
};


/**
 * optional string about_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContestView.prototype.getAboutHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.setAboutHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rules_html = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContestView.prototype.getRulesHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.setRulesHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string announcements_html = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.ContestView.prototype.getAnnouncementsHtmlList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.setAnnouncementsHtmlList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.addAnnouncementsHtml = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.clearAnnouncementsHtmlList = function() {
  return this.setAnnouncementsHtmlList([]);
};


/**
 * optional ScoreboardSettings scoreboard_settings = 4;
 * @return {?proto.io.codedrills.proto.content.ScoreboardSettings}
 */
proto.io.codedrills.proto.content.ContestView.prototype.getScoreboardSettings = function() {
  return /** @type{?proto.io.codedrills.proto.content.ScoreboardSettings} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ScoreboardSettings, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.ScoreboardSettings|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
*/
proto.io.codedrills.proto.content.ContestView.prototype.setScoreboardSettings = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.clearScoreboardSettings = function() {
  return this.setScoreboardSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContestView.prototype.hasScoreboardSettings = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated int32 problem_order = 5;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.ContestView.prototype.getProblemOrderList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.setProblemOrderList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.addProblemOrder = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.ContestView} returns this
 */
proto.io.codedrills.proto.content.ContestView.prototype.clearProblemOrderList = function() {
  return this.setProblemOrderList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.TestView.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TestView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TestView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TestView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TestView.toObject = function(includeInstance, msg) {
  var f, obj = {
    aboutHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    skillsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    role: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TestView}
 */
proto.io.codedrills.proto.content.TestView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TestView;
  return proto.io.codedrills.proto.content.TestView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TestView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TestView}
 */
proto.io.codedrills.proto.content.TestView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAboutHtml(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSkillsList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TestView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TestView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TestView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TestView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAboutHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSkillsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string about_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.TestView.prototype.getAboutHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.TestView} returns this
 */
proto.io.codedrills.proto.content.TestView.prototype.setAboutHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 skills = 2;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.TestView.prototype.getSkillsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.TestView} returns this
 */
proto.io.codedrills.proto.content.TestView.prototype.setSkillsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.TestView} returns this
 */
proto.io.codedrills.proto.content.TestView.prototype.addSkills = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TestView} returns this
 */
proto.io.codedrills.proto.content.TestView.prototype.clearSkillsList = function() {
  return this.setSkillsList([]);
};


/**
 * optional string role = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.TestView.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.TestView} returns this
 */
proto.io.codedrills.proto.content.TestView.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.DrillView.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillView.toObject = function(includeInstance, msg) {
  var f, obj = {
    descriptionHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.io.codedrills.proto.content.DrillSectionView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillView}
 */
proto.io.codedrills.proto.content.DrillView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillView;
  return proto.io.codedrills.proto.content.DrillView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillView}
 */
proto.io.codedrills.proto.content.DrillView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionHtml(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.DrillSectionView;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillSectionView.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescriptionHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.DrillSectionView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillView.prototype.getDescriptionHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillView} returns this
 */
proto.io.codedrills.proto.content.DrillView.prototype.setDescriptionHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string image_url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillView.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillView} returns this
 */
proto.io.codedrills.proto.content.DrillView.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DrillSectionView sections = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.DrillSectionView>}
 */
proto.io.codedrills.proto.content.DrillView.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.DrillSectionView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.DrillSectionView, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.DrillSectionView>} value
 * @return {!proto.io.codedrills.proto.content.DrillView} returns this
*/
proto.io.codedrills.proto.content.DrillView.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.DrillSectionView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.DrillSectionView}
 */
proto.io.codedrills.proto.content.DrillView.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.DrillSectionView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.DrillView} returns this
 */
proto.io.codedrills.proto.content.DrillView.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.DrillSectionView.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillSectionView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillSectionView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillSectionView.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    descriptionHtml: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentViewsList: jspb.Message.toObjectList(msg.getContentViewsList(),
    proto.io.codedrills.proto.content.DrillContentView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillSectionView}
 */
proto.io.codedrills.proto.content.DrillSectionView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillSectionView;
  return proto.io.codedrills.proto.content.DrillSectionView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillSectionView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillSectionView}
 */
proto.io.codedrills.proto.content.DrillSectionView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionHtml(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.DrillContentView;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillContentView.deserializeBinaryFromReader);
      msg.addContentViews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillSectionView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillSectionView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillSectionView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescriptionHtml();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.DrillContentView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillSectionView} returns this
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description_html = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.getDescriptionHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillSectionView} returns this
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.setDescriptionHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DrillContentView content_views = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.DrillContentView>}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.getContentViewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.DrillContentView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.DrillContentView, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.DrillContentView>} value
 * @return {!proto.io.codedrills.proto.content.DrillSectionView} returns this
*/
proto.io.codedrills.proto.content.DrillSectionView.prototype.setContentViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.DrillContentView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.DrillContentView}
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.addContentViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.DrillContentView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.DrillSectionView} returns this
 */
proto.io.codedrills.proto.content.DrillSectionView.prototype.clearContentViewsList = function() {
  return this.setContentViewsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.DrillContentView.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.DrillContentView.ContentCase = {
  CONTENT_NOT_SET: 0,
  USER_CONTENT_PREVIEW: 1
};

/**
 * @return {proto.io.codedrills.proto.content.DrillContentView.ContentCase}
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.getContentCase = function() {
  return /** @type {proto.io.codedrills.proto.content.DrillContentView.ContentCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.DrillContentView.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillContentView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillContentView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillContentView.toObject = function(includeInstance, msg) {
  var f, obj = {
    userContentPreview: (f = msg.getUserContentPreview()) && proto.io.codedrills.proto.content.UserContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillContentView}
 */
proto.io.codedrills.proto.content.DrillContentView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillContentView;
  return proto.io.codedrills.proto.content.DrillContentView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillContentView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillContentView}
 */
proto.io.codedrills.proto.content.DrillContentView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.UserContentPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserContentPreview.deserializeBinaryFromReader);
      msg.setUserContentPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillContentView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillContentView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillContentView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserContentPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.content.UserContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserContentPreview user_content_preview = 1;
 * @return {?proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.getUserContentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserContentPreview} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.UserContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.DrillContentView} returns this
*/
proto.io.codedrills.proto.content.DrillContentView.prototype.setUserContentPreview = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.content.DrillContentView.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DrillContentView} returns this
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.clearUserContentPreview = function() {
  return this.setUserContentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DrillContentView.prototype.hasUserContentPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.TeamView.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TeamView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TeamView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TeamView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentPreview: (f = msg.getContentPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    organizationsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    io_codedrills_proto_user_team_pb.Member.toObject, includeInstance),
    creatorId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    customAttribute: (f = msg.getCustomAttribute()) && io_codedrills_proto_user_team_pb.CustomAttributeMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.content.TeamView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TeamView;
  return proto.io.codedrills.proto.content.TeamView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TeamView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.content.TeamView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setContentPreview(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrganizations(value);
      break;
    case 5:
      var value = new io_codedrills_proto_user_team_pb.Member;
      reader.readMessage(value,io_codedrills_proto_user_team_pb.Member.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorId(value);
      break;
    case 7:
      var value = new io_codedrills_proto_user_team_pb.CustomAttributeMap;
      reader.readMessage(value,io_codedrills_proto_user_team_pb.CustomAttributeMap.deserializeBinaryFromReader);
      msg.setCustomAttribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TeamView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TeamView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TeamView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentPreview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      io_codedrills_proto_user_team_pb.Member.serializeBinaryToWriter
    );
  }
  f = message.getCreatorId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomAttribute();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      io_codedrills_proto_user_team_pb.CustomAttributeMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ContentPreview content_preview = 3;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getContentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
*/
proto.io.codedrills.proto.content.TeamView.prototype.setContentPreview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.clearContentPreview = function() {
  return this.setContentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamView.prototype.hasContentPreview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string organizations = 4;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getOrganizationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.addOrganizations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * repeated io.codedrills.proto.user.Member members = 5;
 * @return {!Array<!proto.io.codedrills.proto.user.Member>}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Member>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_user_team_pb.Member, 5));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Member>} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
*/
proto.io.codedrills.proto.content.TeamView.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Member=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Member}
 */
proto.io.codedrills.proto.content.TeamView.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.io.codedrills.proto.user.Member, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional string creator_id = 6;
 * @return {string}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getCreatorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.setCreatorId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional io.codedrills.proto.user.CustomAttributeMap custom_attribute = 7;
 * @return {?proto.io.codedrills.proto.user.CustomAttributeMap}
 */
proto.io.codedrills.proto.content.TeamView.prototype.getCustomAttribute = function() {
  return /** @type{?proto.io.codedrills.proto.user.CustomAttributeMap} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_team_pb.CustomAttributeMap, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.CustomAttributeMap|undefined} value
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
*/
proto.io.codedrills.proto.content.TeamView.prototype.setCustomAttribute = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.TeamView} returns this
 */
proto.io.codedrills.proto.content.TeamView.prototype.clearCustomAttribute = function() {
  return this.setCustomAttribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamView.prototype.hasCustomAttribute = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SkillView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SkillView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SkillView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SkillView.toObject = function(includeInstance, msg) {
  var f, obj = {
    descriptionHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expertDetailsHtml: jspb.Message.getFieldWithDefault(msg, 2, ""),
    expertImageUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    languageRestriction: (f = msg.getLanguageRestriction()) && io_codedrills_proto_content_content_pb.LanguageRestriction.toObject(includeInstance, f),
    questionSelectionCriteria: (f = msg.getQuestionSelectionCriteria()) && io_codedrills_proto_content_content_pb.QuestionSelectionCriteria.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SkillView}
 */
proto.io.codedrills.proto.content.SkillView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SkillView;
  return proto.io.codedrills.proto.content.SkillView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SkillView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SkillView}
 */
proto.io.codedrills.proto.content.SkillView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionHtml(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpertDetailsHtml(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpertImageUrl(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_content_pb.LanguageRestriction;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.LanguageRestriction.deserializeBinaryFromReader);
      msg.setLanguageRestriction(value);
      break;
    case 5:
      var value = new io_codedrills_proto_content_content_pb.QuestionSelectionCriteria;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.QuestionSelectionCriteria.deserializeBinaryFromReader);
      msg.setQuestionSelectionCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SkillView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SkillView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SkillView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SkillView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescriptionHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpertDetailsHtml();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpertImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguageRestriction();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_content_pb.LanguageRestriction.serializeBinaryToWriter
    );
  }
  f = message.getQuestionSelectionCriteria();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      io_codedrills_proto_content_content_pb.QuestionSelectionCriteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.SkillView.prototype.getDescriptionHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
 */
proto.io.codedrills.proto.content.SkillView.prototype.setDescriptionHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string expert_details_html = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.SkillView.prototype.getExpertDetailsHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
 */
proto.io.codedrills.proto.content.SkillView.prototype.setExpertDetailsHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string expert_image_url = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.SkillView.prototype.getExpertImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
 */
proto.io.codedrills.proto.content.SkillView.prototype.setExpertImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional LanguageRestriction language_restriction = 4;
 * @return {?proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.content.SkillView.prototype.getLanguageRestriction = function() {
  return /** @type{?proto.io.codedrills.proto.content.LanguageRestriction} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.LanguageRestriction, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.LanguageRestriction|undefined} value
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
*/
proto.io.codedrills.proto.content.SkillView.prototype.setLanguageRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
 */
proto.io.codedrills.proto.content.SkillView.prototype.clearLanguageRestriction = function() {
  return this.setLanguageRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SkillView.prototype.hasLanguageRestriction = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QuestionSelectionCriteria question_selection_criteria = 5;
 * @return {?proto.io.codedrills.proto.content.QuestionSelectionCriteria}
 */
proto.io.codedrills.proto.content.SkillView.prototype.getQuestionSelectionCriteria = function() {
  return /** @type{?proto.io.codedrills.proto.content.QuestionSelectionCriteria} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.QuestionSelectionCriteria, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.QuestionSelectionCriteria|undefined} value
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
*/
proto.io.codedrills.proto.content.SkillView.prototype.setQuestionSelectionCriteria = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SkillView} returns this
 */
proto.io.codedrills.proto.content.SkillView.prototype.clearQuestionSelectionCriteria = function() {
  return this.setQuestionSelectionCriteria(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SkillView.prototype.hasQuestionSelectionCriteria = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.McqView.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.McqView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.McqView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.McqView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.McqView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    optionList: jspb.Message.toObjectList(msg.getOptionList(),
    proto.io.codedrills.proto.content.ObjectiveOptionView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.McqView}
 */
proto.io.codedrills.proto.content.McqView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.McqView;
  return proto.io.codedrills.proto.content.McqView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.McqView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.McqView}
 */
proto.io.codedrills.proto.content.McqView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementHtml(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOptionView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader);
      msg.addOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.McqView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.McqView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.McqView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.McqView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.McqView.prototype.getStatementHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.McqView} returns this
 */
proto.io.codedrills.proto.content.McqView.prototype.setStatementHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOptionView option = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>}
 */
proto.io.codedrills.proto.content.McqView.prototype.getOptionList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOptionView, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} value
 * @return {!proto.io.codedrills.proto.content.McqView} returns this
*/
proto.io.codedrills.proto.content.McqView.prototype.setOptionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.McqView.prototype.addOption = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOptionView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.McqView} returns this
 */
proto.io.codedrills.proto.content.McqView.prototype.clearOptionList = function() {
  return this.setOptionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ObjectiveOptionView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    statementHtml: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ObjectiveOptionView;
  return proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatementHtml();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView} returns this
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string statement_html = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.getStatementHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView} returns this
 */
proto.io.codedrills.proto.content.ObjectiveOptionView.prototype.setStatementHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SubjectiveView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SubjectiveView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SubjectiveView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubjectiveView.toObject = function(includeInstance, msg) {
  var f, obj = {
    descriptionHtml: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SubjectiveView}
 */
proto.io.codedrills.proto.content.SubjectiveView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SubjectiveView;
  return proto.io.codedrills.proto.content.SubjectiveView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SubjectiveView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SubjectiveView}
 */
proto.io.codedrills.proto.content.SubjectiveView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SubjectiveView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SubjectiveView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SubjectiveView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubjectiveView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescriptionHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string description_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.SubjectiveView.prototype.getDescriptionHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SubjectiveView} returns this
 */
proto.io.codedrills.proto.content.SubjectiveView.prototype.setDescriptionHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.FillInTheBlanksView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanksView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementHtml: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanksView}
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.FillInTheBlanksView;
  return proto.io.codedrills.proto.content.FillInTheBlanksView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanksView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanksView}
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.FillInTheBlanksView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanksView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string statement_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.prototype.getStatementHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanksView} returns this
 */
proto.io.codedrills.proto.content.FillInTheBlanksView.prototype.setStatementHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.MatchTheFollowingView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowingView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    column1List: jspb.Message.toObjectList(msg.getColumn1List(),
    proto.io.codedrills.proto.content.ObjectiveOptionView.toObject, includeInstance),
    column2List: jspb.Message.toObjectList(msg.getColumn2List(),
    proto.io.codedrills.proto.content.ObjectiveOptionView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.MatchTheFollowingView;
  return proto.io.codedrills.proto.content.MatchTheFollowingView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowingView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementHtml(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOptionView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader);
      msg.addColumn1(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.ObjectiveOptionView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader);
      msg.addColumn2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.MatchTheFollowingView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowingView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumn1List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter
    );
  }
  f = message.getColumn2List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.getStatementHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.setStatementHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOptionView column1 = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.getColumn1List = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOptionView, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView} returns this
*/
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.setColumn1List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.addColumn1 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOptionView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.clearColumn1List = function() {
  return this.setColumn1List([]);
};


/**
 * repeated ObjectiveOptionView column2 = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.getColumn2List = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOptionView, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView} returns this
*/
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.setColumn2List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.addColumn2 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.ObjectiveOptionView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowingView} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowingView.prototype.clearColumn2List = function() {
  return this.setColumn2List([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.OrderTheFollowingView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowingView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementHtml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    columnList: jspb.Message.toObjectList(msg.getColumnList(),
    proto.io.codedrills.proto.content.ObjectiveOptionView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowingView}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.OrderTheFollowingView;
  return proto.io.codedrills.proto.content.OrderTheFollowingView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowingView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowingView}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementHtml(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOptionView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOptionView.deserializeBinaryFromReader);
      msg.addColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.OrderTheFollowingView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowingView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOptionView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement_html = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.getStatementHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowingView} returns this
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.setStatementHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOptionView column = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.getColumnList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOptionView, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOptionView>} value
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowingView} returns this
*/
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.setColumnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOptionView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOptionView}
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.addColumn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOptionView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowingView} returns this
 */
proto.io.codedrills.proto.content.OrderTheFollowingView.prototype.clearColumnList = function() {
  return this.setColumnList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.JobView.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.JobView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.JobView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.JobView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobView.toObject = function(includeInstance, msg) {
  var f, obj = {
    about: jspb.Message.getFieldWithDefault(msg, 1, ""),
    role: jspb.Message.getFieldWithDefault(msg, 2, ""),
    skillsList: jspb.Message.toObjectList(msg.getSkillsList(),
    io_codedrills_proto_content_content_pb.JobSkill.toObject, includeInstance),
    testId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.JobView}
 */
proto.io.codedrills.proto.content.JobView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.JobView;
  return proto.io.codedrills.proto.content.JobView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.JobView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.JobView}
 */
proto.io.codedrills.proto.content.JobView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_content_pb.JobSkill;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.JobSkill.deserializeBinaryFromReader);
      msg.addSkills(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.JobView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.JobView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.JobView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      io_codedrills_proto_content_content_pb.JobSkill.serializeBinaryToWriter
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string about = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.JobView.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.JobView} returns this
 */
proto.io.codedrills.proto.content.JobView.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string role = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.JobView.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.JobView} returns this
 */
proto.io.codedrills.proto.content.JobView.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated JobSkill skills = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.JobSkill>}
 */
proto.io.codedrills.proto.content.JobView.prototype.getSkillsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.JobSkill>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_content_pb.JobSkill, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.JobSkill>} value
 * @return {!proto.io.codedrills.proto.content.JobView} returns this
*/
proto.io.codedrills.proto.content.JobView.prototype.setSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.JobSkill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.JobSkill}
 */
proto.io.codedrills.proto.content.JobView.prototype.addSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.JobSkill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.JobView} returns this
 */
proto.io.codedrills.proto.content.JobView.prototype.clearSkillsList = function() {
  return this.setSkillsList([]);
};


/**
 * optional int32 test_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobView.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobView} returns this
 */
proto.io.codedrills.proto.content.JobView.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.UserContentPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.UserContentPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserContentPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreview: (f = msg.getContentPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    userActivity: (f = msg.getUserActivity()) && io_codedrills_proto_user_user_pb.Activity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.content.UserContentPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.UserContentPreview;
  return proto.io.codedrills.proto.content.UserContentPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.UserContentPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.content.UserContentPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setContentPreview(value);
      break;
    case 2:
      var value = new io_codedrills_proto_user_user_pb.Activity;
      reader.readMessage(value,io_codedrills_proto_user_user_pb.Activity.deserializeBinaryFromReader);
      msg.setUserActivity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.UserContentPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.UserContentPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserContentPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserActivity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_user_user_pb.Activity.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContentPreview content_preview = 1;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.getContentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.UserContentPreview} returns this
*/
proto.io.codedrills.proto.content.UserContentPreview.prototype.setContentPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.UserContentPreview} returns this
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.clearContentPreview = function() {
  return this.setContentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.hasContentPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.user.Activity user_activity = 2;
 * @return {?proto.io.codedrills.proto.user.Activity}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.getUserActivity = function() {
  return /** @type{?proto.io.codedrills.proto.user.Activity} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_user_pb.Activity, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.Activity|undefined} value
 * @return {!proto.io.codedrills.proto.content.UserContentPreview} returns this
*/
proto.io.codedrills.proto.content.UserContentPreview.prototype.setUserActivity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.UserContentPreview} returns this
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.clearUserActivity = function() {
  return this.setUserActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.UserContentPreview.prototype.hasUserActivity = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.SubmissionView.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SubmissionView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SubmissionView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubmissionView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    problemPreview: (f = msg.getProblemPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    userPreview: (f = msg.getUserPreview()) && io_codedrills_proto_content_preview_pb.UserPreview.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submissionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    timeTakenInMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
    memoryTakenInKb: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 9, 0),
    runId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    code: jspb.Message.getFieldWithDefault(msg, 11, ""),
    sampleResultViewsList: jspb.Message.toObjectList(msg.getSampleResultViewsList(),
    io_codedrills_proto_judge_judge_pb.TestResultView.toObject, includeInstance),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SubmissionView}
 */
proto.io.codedrills.proto.content.SubmissionView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SubmissionView;
  return proto.io.codedrills.proto.content.SubmissionView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SubmissionView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SubmissionView}
 */
proto.io.codedrills.proto.content.SubmissionView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setProblemPreview(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_preview_pb.UserPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.UserPreview.deserializeBinaryFromReader);
      msg.setUserPreview(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (reader.readEnum());
      msg.setSubmissionType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeTakenInMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemoryTakenInKb(value);
      break;
    case 8:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 12:
      var value = new io_codedrills_proto_judge_judge_pb.TestResultView;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.TestResultView.deserializeBinaryFromReader);
      msg.addSampleResultViews(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SubmissionView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SubmissionView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubmissionView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getProblemPreview();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserPreview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_preview_pb.UserPreview.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSubmissionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTimeTakenInMs();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMemoryTakenInKb();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getRunId();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSampleResultViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      io_codedrills_proto_judge_judge_pb.TestResultView.serializeBinaryToWriter
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
};


/**
 * optional fixed32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ContentPreview problem_preview = 2;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getProblemPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
*/
proto.io.codedrills.proto.content.SubmissionView.prototype.setProblemPreview = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.clearProblemPreview = function() {
  return this.setProblemPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.hasProblemPreview = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserPreview user_preview = 3;
 * @return {?proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getUserPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.UserPreview, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
*/
proto.io.codedrills.proto.content.SubmissionView.prototype.setUserPreview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.clearUserPreview = function() {
  return this.setUserPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.hasUserPreview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional io.codedrills.proto.judge.Language language = 4;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional io.codedrills.proto.judge.SubmissionType submission_type = 5;
 * @return {!proto.io.codedrills.proto.judge.SubmissionType}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getSubmissionType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setSubmissionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 time_taken_in_ms = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getTimeTakenInMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setTimeTakenInMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 memory_taken_in_kb = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getMemoryTakenInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setMemoryTakenInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional io.codedrills.proto.judge.Status status = 8;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 submitted_on = 9;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 run_id = 10;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getRunId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setRunId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string code = 11;
 * @return {string}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated io.codedrills.proto.judge.TestResultView sample_result_views = 12;
 * @return {!Array<!proto.io.codedrills.proto.judge.TestResultView>}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getSampleResultViewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.TestResultView>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.TestResultView, 12));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.TestResultView>} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
*/
proto.io.codedrills.proto.content.SubmissionView.prototype.setSampleResultViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.TestResultView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.TestResultView}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.addSampleResultViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.io.codedrills.proto.judge.TestResultView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.clearSampleResultViewsList = function() {
  return this.setSampleResultViewsList([]);
};


/**
 * optional double score = 13;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionView} returns this
 */
proto.io.codedrills.proto.content.SubmissionView.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContentViewWithPublish.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContentViewWithPublish} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentView: (f = msg.getContentView()) && proto.io.codedrills.proto.content.ContentView.toObject(includeInstance, f),
    publishType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContentViewWithPublish}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContentViewWithPublish;
  return proto.io.codedrills.proto.content.ContentViewWithPublish.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContentViewWithPublish} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContentViewWithPublish}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.ContentView;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContentView.deserializeBinaryFromReader);
      msg.setContentView(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.PublishType} */ (reader.readEnum());
      msg.setPublishType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContentViewWithPublish.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContentViewWithPublish} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.content.ContentView.serializeBinaryToWriter
    );
  }
  f = message.getPublishType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional ContentView content_view = 1;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.getContentView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContentView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContentViewWithPublish} returns this
*/
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.setContentView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentViewWithPublish} returns this
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.clearContentView = function() {
  return this.setContentView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.hasContentView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PublishType publish_type = 2;
 * @return {!proto.io.codedrills.proto.content.PublishType}
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.getPublishType = function() {
  return /** @type {!proto.io.codedrills.proto.content.PublishType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.PublishType} value
 * @return {!proto.io.codedrills.proto.content.ContentViewWithPublish} returns this
 */
proto.io.codedrills.proto.content.ContentViewWithPublish.prototype.setPublishType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.io.codedrills.proto.content);
